<template>
  <div>
    <!-- Affichage d'une barre de progression pendant le chargement des données -->
    <load-progress :condition="!dataLoaded" label="Chargement des données"></load-progress>
    <!-- Affichage du tree view et des éditeurs selon l'objet sélectionné -->

    <div v-if="dataLoaded">
        <fiche-container ref="FICHE_CONTAINER"
                         :fiche="selectedFiche"
                         :route="notifRoute"
                         :attribut="attribut"
                         :route-element="routeElement"
                         @back="back"
                         @selectItem="selectItem">
        </fiche-container>
    </div>
    <div v-for="(button, index) in extraButtons" :key="index">
      <loader-button class="ms-2"
                     :outlined="button.outlined"
                     @callback="button.callback()"
                     :label="button.label"
                     :disabled="button.disabled">
      </loader-button>
    </div>
    <section-container :dialogOpen="showWizard"
                       :section="sectionWizard"
                       @closeDialog="hideWizard">
    </section-container>
  </div>
</template>

<script lang="ts">
  import { defineComponent, markRaw, type PropType } from "vue";
  import LoadProgress from '@/framework/base/components/LoadProgress.vue';
  import {
    storeSession,
    storeUser,
    storeNotif
  } from '@/generated/stores';
  import { CiRouter } from '@/framework/base/helpers/NavHelper';
  import Route from '@/generated/classes/Route';
  import ModuleBase from '@/framework/base/components/ModuleBase';
  import FicheCartItemListExtend from '@/extend/fiches/FicheCartItemListExtend.vue';
  import SectionCartItemList from '@/custom/sections/SectionCartItemList.vue';
  import { Fiches, Modules, Sections } from '@/generated/classes/AppSchema';
  import { GenModule, RessourceGenModule } from '@/generated/ressources/generatedRessources';
  import Wizard from '@/extend/classes/Wizard';
  import Section from '@/framework/base/classes/Section';
  import SectionWizard from '@/framework/wizard/components/SectionWizard.vue';
  import Fiche from '@/framework/base/classes/Fiche';
  import { RouteElements } from '@/framework/base/classes/Section';
  import User from '@/generated/classes/User';
  import FicheContainerAbstract from "@/framework/base/components/FicheContainerAbstract.vue";

  export function ModuleCartOpenFiche(route: Route | undefined): RouteElements {
    const section = new Section();
    const fiche = new Fiche();
    if (route && route.fiche) {
      switch (route.fiche) {
        case Fiches.CART_ITEM_LIST: {
          fiche.component = FicheCartItemListExtend;
          break;
        }
        case Fiches.CONTAINER: {
          fiche.component = FicheContainerAbstract;
          break;
        }
      }
    } else {
      fiche.component = FicheCartItemListExtend;
    }
    if (route && route.section && route.section != Sections.NONE) {
      switch (route.section) {
        case Sections.CART_ITEM_LIST: {
          section.component = SectionCartItemList;
          section.showButton = true;
          break;
        }
      }
    }
    if (fiche && fiche.component) {
      fiche.component = markRaw(fiche.component);
    }
    if (section && section.component) {
      section.component = markRaw(section.component);
    }
    const res = new RouteElements();
    res.fiche = fiche;
    res.section = section;
    return res;
  }

  export default defineComponent({
    extends: ModuleBase,
    components: {
      LoadProgress,
    },

    props: {
    },

    created (): void {
      if (this.route) {
        this.notifRoute = this.route;
      }
      const session = storeSession.connectedUser;
      if (session) {
        const user = storeUser.getUser(session.id);
        if (user.modules.includes(Modules.CART)) {
          this.wizardDone = true;
        }
      }
      if (!this.wizardDone) {
        Wizard.showWizard(Modules.CART).then((res) => {
          if (res.id > 0) {
            this.wizard = res;
            this.showWizard = true;
          } else {
            User.acceptCgu(true);
            this.wizardDone = true;
          }
        })
      }
      this.loadStores();
    },

    data() {
      const attribut: unknown = undefined;
      const route = CiRouter.getRoute();
      return {
        wizard: new Wizard(),
        attribut,
        notifRoute: new Route(),
        route,
      }
    },

    computed: {
      ressource () {
        return RessourceGenModule(GenModule.MODULE_CART);
      },
      sectionWizard (): Section {
        const section = new Section();
        section.component = SectionWizard;
        section.data = this.wizard;
        section.helper = true;
        return section;
      },

      storesLoaded (): boolean {
        return true;
      },

      dataLoaded (): boolean {
        const res = this.wizardDone && this.storesLoaded
        if (res && this.init) {
          this.setInit(false);
          if (!this.route) {
            this.selectItem(this.route);
          }
          CiRouter.setRouteChangedSelector(this.routeChanged);
        }
        return res;
      }
    },

    methods: {
      loadStores() : void{
        // Load and register events on used server classes
        storeNotif.registerNotif();
      },
      setInit(value: boolean) : void{
        this.init = value;
      },
      routeChanged (route: Route): void {
        this.selectItem(route);
      },
      selectItem(route: Route | undefined): void {
        const routeElement = ModuleCartOpenFiche(route);
        this.routeElement = routeElement;
        this.selectedFiche = routeElement.fiche;
        this.selectedFiche.ressourceHeader = this.ressource;
        if (route) {
          this.notifRoute = route;
          if (route && route.attribut) {
            this.attribut = route.attribut;
          } else {
            this.attribut = undefined;
          }
          if (route.section && route.section != Sections.NONE) {
            this.lastShowSection = !this.lastShowSection;
            this.selectedFiche.showSection = this.lastShowSection;
          }
        }
        const index = this.lastSelectedFiche.findIndex(item => {
          return item.component === this.selectedFiche.component;
        })
        if (index >= 0) {
          this.lastRoutes.splice(index + 1)
          this.lastSelectedFiche.splice(index + 1)
        } else {
          this.lastRoutes.push(route);
          this.lastSelectedFiche.push(this.selectedFiche);
        }
      }
    }
  })
</script>
